import React, { useState} from 'react'

export const InputContext = React.createContext(null)

export default function InputProvider({ children }) {
  const negAdjective = 'NEGATIVE ADJECTIVE'
  const PluralNounOne = 'PLURAL NOUN'
  const PluralNounTwo = 'PLURAL NOUN'
  const SeaCreature = 'PLURAL NOUN, A SEA CREATURE'
  const Insect = 'PLURAL NOUN, AN INSECT'
  const Adjective = 'ADJECTIVE'


  const [negAdj, setNegAdj] = useState(negAdjective)
  const [plNounOne, setPlNounOne] = useState(PluralNounOne)
  const [plNounTwo, setPlNounTwo] = useState(PluralNounTwo)
  const [seaCre, setSeaCre] = useState(SeaCreature)
  const [insect, setInsect] = useState(Insect)
  const [adj, setAdj] = useState(Adjective)

  

  return <InputContext.Provider value={{negAdj, setNegAdj, plNounOne, setPlNounOne, plNounTwo, setPlNounTwo, seaCre, setSeaCre, insect, setInsect, adj, setAdj }}>{children}</InputContext.Provider>
}
